import React from 'react';

import {Stack} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {IconContainer, StyledTypography} from './styles';
import {SuccessHeaderProps} from './types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {confirmationPage} = translations['pt-br'].privateFlow.bookingFlow;

export function SuccessHeader({flowType}: SuccessHeaderProps) {
	const isExam = flowType === FlowEnum.EXAM;

	return (
		<Stack alignItems="center" gap={1}>
			<IconContainer>
				<Icon name="check-default" size={32} />
			</IconContainer>
			<StyledTypography variant="h6" fontSize={24} fontWeight={600} textAlign="center">
				{isExam ? confirmationPage.examSuccessTitle : confirmationPage.successTitle}
			</StyledTypography>
			<StyledTypography variant="body1" color="primary.dark" textAlign="center">
				{confirmationPage.successSubtitle}
			</StyledTypography>
		</Stack>
	);
}
